import { useEffect, useRef, useState } from "react";
import { isBackendDown, retryBackendConnection } from "../lib/networkMiddleware";
import { AlertTriangle, CheckCircle2 } from "lucide-react";

export default function ReconnectingBanner() {
  const [down, setDown] = useState(false);
  const [recovered, setRecovered] = useState(false);
  const [checking, setChecking] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const since = useRef(null);
  useEffect(() => {
    let debounce, green, ticker, shown = false;
    const onDown = () => {
      clearTimeout(green); setRecovered(false);
      if (debounce || shown) return;
      since.current = Date.now();
      debounce = setTimeout(() => {
        debounce = null;
        if (!isBackendDown()) return;
        shown = true; setDown(true);
        ticker = setInterval(() => setSeconds(Math.floor((Date.now() - since.current) / 1000)), 1000);
      }, 2500);
    };
    const onUp = () => {
      clearTimeout(debounce); debounce = null;
      clearInterval(ticker); setDown(false); setSeconds(0);
      if (shown) { setRecovered(true); green = setTimeout(() => setRecovered(false), 4000); }
      shown = false; since.current = null;
    };
    window.addEventListener("backend-down", onDown);
    window.addEventListener("backend-up", onUp);
    if (isBackendDown()) onDown();
    return () => {
      clearTimeout(debounce); clearTimeout(green); clearInterval(ticker);
      window.removeEventListener("backend-down", onDown); window.removeEventListener("backend-up", onUp);
    };
  }, []);
  if (!down && !recovered) return null;
  return <div role="status" className={`fixed top-0 inset-x-0 z-[9999] text-white text-sm font-medium shadow-lg ${down ? "bg-red-600" : "bg-emerald-600"}`}
    data-testid={down ? "reconnecting-banner" : "reconnecting-banner-recovered"}>
    <div className="max-w-6xl mx-auto px-4 py-2.5 flex items-center gap-3">
      {down ? <AlertTriangle className="h-4 w-4 shrink-0" /> : <CheckCircle2 className="h-4 w-4 shrink-0" />}
      <div className="flex-1 min-w-0">{down ? <><strong>Connection interrupted</strong> — reconnecting automatically{seconds ? ` (${seconds}s)` : ""}…</> : <><strong>Reconnected</strong> — you can continue working.</>}</div>
      {down && <button disabled={checking} onClick={async () => { setChecking(true); try { await retryBackendConnection(); } finally { setChecking(false); } }}
        className="rounded-md px-3 py-1 bg-white/10 hover:bg-white/20 text-xs font-semibold shrink-0 disabled:opacity-50"
        data-testid="reconnecting-banner-refresh">{checking ? "Checking…" : "Retry now"}</button>}
    </div>
  </div>;
}